module.exports = __webpack_public_path__ + "img/four4Orange.a77f82da.jpg";